import { render } from "./SelectPoint.vue?vue&type=template&id=47c088af&scoped=true"
import script from "./SelectPoint.vue?vue&type=script&lang=js"
export * from "./SelectPoint.vue?vue&type=script&lang=js"

import "./SelectPoint.vue?vue&type=style&index=0&id=47c088af&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c088af"]])

export default __exports__